/**
 * Agent Mode Indicator
 * 
 * Shows which document the AI Agent will edit.
 * Provides clear visual feedback for multi-document editing context.
 */

interface AgentModeIndicatorProps {
  documentNumber: string;
  documentTitle: string;
  tabId: number;
}

export default function AgentModeIndicator({
  documentNumber,
  documentTitle: _documentTitle,
  tabId
}: AgentModeIndicatorProps) {
  // _documentTitle is available for future use
  void _documentTitle;
  return (
    <div className="px-4 py-2 bg-secondary/10 border-b border-border">
      <div className="flex items-center gap-2 text-sm">
        <svg className="w-4 h-4 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span className="font-medium text-foreground">
          Agent Mode Active
        </span>
        <span className="text-muted-foreground">→</span>
        <span className="text-foreground">
          Editing: <strong>{documentNumber}</strong>
        </span>
        <span className="text-xs text-muted-foreground bg-secondary/20 px-2 py-0.5 rounded">
          Tab {tabId}
        </span>
      </div>
      <div className="text-xs text-muted-foreground mt-1">
        AI will make changes to this document. Switch tabs to edit a different document.
      </div>
    </div>
  );
}

